import { checkSession } from './services/session/'
import { setSocketStatus } from './services/connection'
import { batch } from './modules/lib/batchReducer'

const feathersMiddleware = socket => store => {
  if (process.env.NODE_ENV === 'test') return next => action => next(action)

  store.dispatch(batch('SOCKET_DISCONNECTED', setSocketStatus(false)))

  socket.on('connect', () => {
    console.log('Socket connected')
    store.dispatch(batch('SOCKET_CONNECTED', setSocketStatus(true)))
    store.dispatch(checkSession())
  })
  socket.on('disconnect', () => {
    // TODO: despachar acciones cuando tengamos UI para mostrar estado de conexion
    store.dispatch(batch('SOCKET_DISCONNECTED', setSocketStatus(false)))
    console.log('Socket disconnected')
  })
  socket.on('reconnect', () => {
    // TODO: despachar acciones cuando tengamos UI para mostrarl el estado de conexion
    store.dispatch(batch('SOCKET_RECONNECTED', setSocketStatus(true)))
    console.log('Socket reconnected')
  })

  return next => action => {
    return next(action)
  }
}

export default feathersMiddleware



// WEBPACK FOOTER //
// ./src/feathers-middleware.js